import React, { useState, useEffect, useRef } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  TextField,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { DataGrid } from "@mui/x-data-grid";
import { GRNNormalRo } from "../../../Redux/roStore";
import { fcheck_null_undefine_replace_empty } from "../../../Utility/Utilitys";
import { sTrnTyp } from "../GRVAction";
import { GRNNormal_RefDocumentNo_GETROW, inv04_RefDocumentNo_GETROW } from "../../../Server/ApiV2";

const PoNoSearchModal = ({
  open,
  onClose,
  defaultValue = "",
  handleRowClick,
  B_RefDocTyp=""
}) => {
  const [anyData, setAnyData] = useState(defaultValue || "");
  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [gridData, setGridData] = useState([]); // Grid data state
  const dataGridRef = useRef(); // Ref to handle DataGrid focus

  // Handle input change
  const handleInputChange = (setter) => (e) => {
    setter(e.target.value);
  };

  // Handle Clear action
  const handleClear = () => {
    setAnyData("");
    setCode("");
    setName("");
    setGridData([]);
  };

  // Trigger API call when the Enter key is pressed
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleLoad(); // Call API when Enter is pressed
    }
    if (e.keyCode === 40 && gridData.length > 0) {
      fCheckKey(e);
    }
  };

  // Handle both Enter key for API call and Arrow Down for focusing the grid
  const fCheckKey = (event) => {
    setTimeout(() => {
      if (event.keyCode === 40 && gridData.length > 0) {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let table = document.getElementById("table-main-grid");
          table
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            .firstChild?.focus();
        }
      }
    }, 500);
  };
  const handleLoad = async () => {
    const { HeadObject } = GRNNormalRo();
    const payload = {
      v_AnyData: anyData != "" ? anyData : defaultValue,
      v_TrnTyp: sTrnTyp, 
      v_VocTyp: B_RefDocTyp,
    };
    let resp = await inv04_RefDocumentNo_GETROW(
      fcheck_null_undefine_replace_empty(payload)
    );
    if (resp?.status === 200) {
      console.log(resp);
      let respData =
        resp?.data?.ResultSet?.length == 0
          ? []
          : resp?.data?.ResultSet.map((obj, i) => ({
              ...obj,
              id: i + 1,
              Name1: obj.A_VocNo[0],
              UID: obj.A_VocNo[0]
            }));

      setGridData(respData);
    } else {
      setGridData([]);
    }
  };

  useEffect(() => {
    // Add keydown listener for arrow navigation
    if (open && defaultValue != "") {
      handleLoad();
    }
    setAnyData(defaultValue);
  }, [open]);

  // useEffect(() => {
  //   // Add keydown listener for arrow navigation
  //   window.addEventListener("keydown", fCheckKey);
  //   return () => {
  //     window.removeEventListener("keydown", fCheckKey);
  //   };
  // }, [gridData]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      {/* Adjusted Title with Proper Icon Alignment */}
      <DialogTitle
        sx={{
          backgroundColor: "primary.main",
          color: "white",
          padding: "8px 16px",
          display: "flex", // Use flex to align items
          alignItems: "center", // Vertically center
          justifyContent: "space-between", // Push title to the left and icon to the right
          minHeight: "20px", // Adjust title height to 20px
        }}
      >
        <Typography
          variant="h6"
          component="div"
          sx={{ fontSize: "1rem", lineHeight: "20px" }} // Match height with title
        >
          Po No
        </Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            color: "white",
            padding: "0", // Remove extra padding
            marginLeft: "auto", // Align to the right
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent
        sx={{
          padding: "24px", // Add some padding to the content for better spacing
          marginTop: 3,
        }}
      >
        {/* Input Fields */}
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={6} sm={4}>
            <Typography
              variant="h6"
              component="div"
              sx={{ fontSize: "0.8rem", lineHeight: "20px" }} // Match height with title
            >
              Any Data
            </Typography>
            <TextField
              fullWidth
              // label="Any Data"
              value={anyData}
              onChange={handleInputChange(setAnyData)}
              onKeyUp={handleKeyPress} // Call API on Enter key
              size="small"
              autoFocus // Ensure autofocus on load
              InputLabelProps={{
                shrink: true, // Ensure label shrinks when focused
              }}
            />
          </Grid>
          <Grid item xs={6} sm={4}>
            <Typography
              variant="h6"
              component="div"
              sx={{ fontSize: "0.8rem", lineHeight: "20px" }} // Match height with title
            >
              Code
            </Typography>
            <TextField
              fullWidth
              // label="Code"
              value={code}
              onChange={handleInputChange(setCode)}
              onKeyUp={handleKeyPress} // Call API on Enter key
              size="small"
              InputLabelProps={{
                shrink: true, // Ensure label shrinks when focused
              }}
            />
          </Grid>
          <Grid item xs={6} sm={4}>
            <Typography
              variant="h6"
              component="div"
              sx={{ fontSize: "0.8rem", lineHeight: "20px" }} // Match height with title
            >
              Name
            </Typography>
            <TextField
              fullWidth
              // label="Name"
              value={name}
              onChange={handleInputChange(setName)}
              onKeyUp={handleKeyPress} // Call API on Enter key
              size="small"
              InputLabelProps={{
                shrink: true, // Ensure label shrinks when focused
              }}
            />
          </Grid>
        </Grid>

        {/* DataGrid for displaying search results */}
        <div
          id="table-main-grid"
          ref={dataGridRef}
          style={{ height: 300, width: "100%", marginTop: 20 }}
        >
          <DataGrid
            rowHeight={30}
            headerHeight={40}
            rows={gridData}
            columns={[
              { field: "UID", headerName: "Code", width: 150 },
              { field: "Name1", headerName: "Name", width: 150 },
            ]}
            pageSize={5}
            disableSelectionOnClick
            hideFooter={gridData.length < 100}
            onRowClick={handleRowClick}
          />
        </div>
      </DialogContent>

      <DialogActions
        sx={{ padding: "16px", marginTop: "16px" }} // Add padding and margin-top for better spacing
      >
        <Button variant="contained" onClick={handleLoad}>
          Load
        </Button>
        <Button variant="contained" onClick={handleClear} color="warning">
          Clear
        </Button>
        <Button onClick={onClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
};

export default PoNoSearchModal;
